import React, { FC } from 'react';

import { Layout } from '@/shared/ui';
import { GuideInfo } from '@/widgets/GuideInfo';
import { SegmentButtonGroup } from '@/widgets/SegmentButtonGroup';
import { Faqs } from '@/widgets/FAQs';
import { AssetsToBorrowSection, UserBorrowsSection } from '@/features/Pools';
import { AssetsToClaim } from '@/features/AssetsToClaim';

export const Borrow: FC = () => {
    return (
        <div>
            <Layout isBorder>
                <GuideInfo />
                <SegmentButtonGroup />
            </Layout>
            <Layout>
                <UserBorrowsSection />
                <AssetsToClaim />
                <AssetsToBorrowSection />
            </Layout>
            <Faqs />
        </div>
    );
};
